// extracted by css-extract-rspack-plugin
export default {"root":"gyzZkMhpI10KpqFp","content":"OKO23xzUgKU_X09e","heading":"MFZBBG1Lud8tIVqt"};